import React from 'react'

import { SimNaoEnum } from './SimNaoRadioGroupField'
import { SwitchButtonField, SwitchButtonFieldProps } from './SwitchButtonField'

interface SimNaoSwitchButtonFieldProps extends Omit<SwitchButtonFieldProps<SimNaoEnum>, 'options'> {}

export function SimNaoSwitchButtonField(props: SimNaoSwitchButtonFieldProps) {
  return (
    <SwitchButtonField<SimNaoEnum>
      options={[
        { label: 'Sim', value: SimNaoEnum.SIM },
        { label: 'Não', value: SimNaoEnum.NAO },
      ]}
      {...props}
    />
  )
}
